import styled from 'styled-components';

import { MOBILE } from '../../theme/tokens';

/** Max width of the settings CONTENT — the index menu rows and each subpage's
 *  section. The drill-in BackHeader is deliberately exempt (stays full-bleed). */
const CONTENT_MAX = '960px';

/** The settings index (menu) column: content-capped + centred, with a little top
 *  breathing room below the page header. */
export const Constrain = styled.div`
  width: 100%;
  max-width: ${CONTENT_MAX};
  margin: 24px auto 0;
  display: flex;
  flex-direction: column;
  gap: 12px;

  ${MOBILE} {
    margin-top: 8px;
    max-width: none;
  }
`;

/**
 * A settings drill-in subpage: the full-bleed BackHeader plus its section. The
 * BackHeader spans the page column (like every other detail subpage); the section
 * itself is content-capped via `Contents`. Owns the title↔content gap.
 */
export const SubPage = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  ${MOBILE} {
    gap: 14px;
  }
`;

/** A subpage's section content (the form / panel): content-capped + centred under
 *  the full-bleed BackHeader. Stacks its children as a flex column with a gap so a
 *  multi-panel section (e.g. Account: Password · Connected accounts · Sessions)
 *  spaces its panels; single-child sections are unaffected (no gap with one child). */
export const Contents = styled.div`
  width: 100%;
  max-width: ${CONTENT_MAX};
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 16px;

  ${MOBILE} {
    gap: 14px;
  }
`;
